/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type omItdagene_QueryVariables = {};
export type omItdagene_QueryResponse = {
    readonly currentMetaData: {
        readonly year: number | null;
        readonly id: string;
        readonly boardMembers: ReadonlyArray<{
            readonly id: string;
            readonly role: string | null;
            readonly fullName: string | null;
            readonly linkedin: string | null;
            readonly " $fragmentRefs": FragmentRefs<"BoardMember_user">;
        }>;
    };
    readonly omItdagene: {
        readonly " $fragmentRefs": FragmentRefs<"PageView_page" | "metadata_metadata">;
    } | null;
};
export type omItdagene_Query = {
    readonly response: omItdagene_QueryResponse;
    readonly variables: omItdagene_QueryVariables;
};



/*
query omItdagene_Query {
  currentMetaData {
    year
    id
    boardMembers {
      ...BoardMember_user
      id
      role
      fullName
      linkedin
    }
  }
  omItdagene: page(slug: "om-itdagene") {
    ...PageView_page
    ...metadata_metadata
    id
  }
}

fragment BoardMember_user on User {
  id
  photo(width: 250, height: 250)
  fullName
  role
  email
  linkedin
}

fragment PageView_page on Page {
  id
  content
  slug
  title
  dateSaved
  dateCreated
  videoFile
}

fragment metadata_metadata on OpengraphMetadata {
  __isOpengraphMetadata: __typename
  title
  description
  sharingImage
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkedin",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "slug",
    "value": "om-itdagene"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "omItdagene_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MetaData",
        "kind": "LinkedField",
        "name": "currentMetaData",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "boardMembers",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BoardMember_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "omItdagene",
        "args": (v5/*: any*/),
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PageView_page"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "metadata_metadata"
          }
        ],
        "storageKey": "page(slug:\"om-itdagene\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "omItdagene_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MetaData",
        "kind": "LinkedField",
        "name": "currentMetaData",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "boardMembers",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "height",
                    "value": 250
                  },
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 250
                  }
                ],
                "kind": "ScalarField",
                "name": "photo",
                "storageKey": "photo(height:250,width:250)"
              },
              (v3/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "omItdagene",
        "args": (v5/*: any*/),
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateSaved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoFile",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sharingImage",
                "storageKey": null
              }
            ],
            "type": "OpengraphMetadata",
            "abstractKey": "__isOpengraphMetadata"
          }
        ],
        "storageKey": "page(slug:\"om-itdagene\")"
      }
    ]
  },
  "params": {
    "cacheID": "b711a17b24669da474b33992ffb0752e",
    "id": null,
    "metadata": {},
    "name": "omItdagene_Query",
    "operationKind": "query",
    "text": "query omItdagene_Query {\n  currentMetaData {\n    year\n    id\n    boardMembers {\n      ...BoardMember_user\n      id\n      role\n      fullName\n      linkedin\n    }\n  }\n  omItdagene: page(slug: \"om-itdagene\") {\n    ...PageView_page\n    ...metadata_metadata\n    id\n  }\n}\n\nfragment BoardMember_user on User {\n  id\n  photo(width: 250, height: 250)\n  fullName\n  role\n  email\n  linkedin\n}\n\nfragment PageView_page on Page {\n  id\n  content\n  slug\n  title\n  dateSaved\n  dateCreated\n  videoFile\n}\n\nfragment metadata_metadata on OpengraphMetadata {\n  __isOpengraphMetadata: __typename\n  title\n  description\n  sharingImage\n}\n"
  }
};
})();
(node as any).hash = '76fb95978489d2592f58303e6c4e0257';
export default node;
